import { prefetchOdspTokens, preload } from '@ms/office-web-host';
import { getBposNavBarData } from 'owa-bpos-store';
import { createLazyOrchestrator } from 'owa-bundling';
import { getLogicalRing } from 'owa-config';
import { preloadFluid } from 'owa-fluid-tenantconfig';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FluidTokenProvider } from '../utils/fluidProps/fluidTokenProvider';
import { preloadDiscoverManifest } from '../utils/preloadDiscoverManifest';

export const preloadFluidOrchestrator = createLazyOrchestrator(
    preloadFluid,
    'preloadFluidClone',
    () => {
        if (isFeatureEnabled('cmp-fluid-preloadScripts')) {
            preload({
                isolationConfig:
                    isFeatureEnabled('cmp-fluid-sourcelessIFrame') ||
                    isFeatureEnabled('cmp-fluid-sourcelessIFrameAlways')
                        ? undefined
                        : {
                              useIframe: true,
                          },
            });
        }

        // We can get bpos data sync because we already needed to fetch it to make sure fluid was enabled,
        // before we reach this point.
        const bposNavBarData = getBposNavBarData();

        const tokenProvider = new FluidTokenProvider();
        const tokenSites = [bposNavBarData!.SPO_MySiteHostUrl, bposNavBarData!.SPO_RootSiteUrl];

        // For MSIT users we fetch the tokens for both spdf and regualr sharepoint
        const logicalRing = getLogicalRing();
        if (logicalRing === 'Dogfood' || logicalRing === 'Microsoft') {
            const extraSites = [
                'https://microsoft-my.sharepoint-df.com/',
                'https://microsoft.sharepoint-df.com/',
                'https://microsoft-my.sharepoint.com/',
                'https://microsoft.sharepoint.com/',
            ];
            extraSites.forEach(site => {
                if (tokenSites.indexOf(site) === -1) {
                    tokenSites.push(site);
                }
            });
        }

        prefetchOdspTokens(tokenProvider, tokenSites);
        preloadDiscoverManifest();
    }
);
